export class ErrorRequest {
  error: {
    message: string;
  };
}
